import { forwardRef } from 'react';

const PanelBody = ({ children, className = '', style = {}, ...props }) => {
  return (
    <div className={`comp-panel-body ${className}`} style={style} {...props}>
      {children}
    </div>
  );
};

const FixedContent = ({ children, gap = 'sm', className = '', style = {} }) => {
  return (
    <div className={`comp-panel-body-fixed-content ${className} gap-${gap}`} style={style}>
      {children}
    </div>
  );
};

const ScrollableContent = forwardRef(({ children, gap = 'sm', className = '', style = {} }, ref) => {
  return (
    <div ref={ref} className={`comp-panel-body-scrollable-content ${className} gap-${gap}`} style={style}>
      {children}
    </div>
  );
});

ScrollableContent.displayName = 'ScrollableContent';

PanelBody.FixedContent = FixedContent;
PanelBody.ScrollableContent = ScrollableContent;

export default PanelBody;
